import PropTypes from 'prop-types';
// material - use @mui/material so created theme has applyStyles (required by MUI 5.18+ Avatar, etc.)
import { ThemeProvider, createTheme, useTheme } from '@mui/material/styles';
import { enUS } from '@mui/material/locale';

// ----------------------------------------------------------------------
// MUI components (TablePagination, DataGrid, etc.) always use English locale;
// app UI translations still follow useLocales / i18n.

ThemeLocalization.propTypes = {
  children: PropTypes.node
};

export default function ThemeLocalization({ children }) {
  const defaultTheme = useTheme();
  const theme = createTheme(defaultTheme, enUS);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
